import axios from 'axios';

// نقاط الـ API (contact.php / chat.php) بتعيش جنب الموقع نفسه على Bluehost (نفس الدومين).
// لو حبيت تستضيف الباك اند في مكان تاني، حط عنوانه في REACT_APP_BACKEND_URL وقت البناء.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = BACKEND_URL; // فاضي = نفس الدومين

export const api = axios.create({
  baseURL: API,
  timeout: 30000,
});
